import bannerImage from "../assets/images/initiatives/etheader.webp";
import scrollimage1 from "../assets/images/products/app1.webp";
import scrollimage2 from "../assets/images/products/app2.webp";
import scrollimage3 from "../assets/images/products/app3.webp";

export const headerData = {
  image: bannerImage,
  heading: "Truth Estimation",
  desc: "A transparent AI framework that estimates truth from evidence and collaboration, forming the backbone of Spiritual Data's products.",
};

export const tiltHeadData = {
  bgText: "Truth Estimation",
  title: "Truth Estimation Framework Initiative",
  desc: "The Truth Estimation Framework, also called Concept AI, is the core foundation of Spiritual Data's mission. It provides a transparent, evidence-based system for estimating what is true by combining research papers, written experiences, and AI-driven decision automation representing diverse perspectives. Unlike biased alternatives, this framework enables open collaboration with researchers worldwide, ensures every conclusion is backed by clear methodology, and serves as the scientific backbone for all Spiritual Data products.",
};

export const scrollCardsData = [
  {
    title: "Background",
    desc: "The truth estimation framework is called Concept AI. It is also referred to as a decision automation framework. Truth estimation requires automation based on evidential data, such as research papers and written human experiences. In the future, other types of data may be supported.",
    btn: "Learn the Science Behind It",
    img: scrollimage1,
    link: "/products/concept-ai",
  },
  {
    title: "Purpose",
    desc: "Provide an AI automation framework that leverages the benefits of LLMs to make decisions based on all relevant data, especially for scientific conclusions. This framework also enables open collaboration with researchers, domain experts, and the public to validate both the data and methodology.",
    btn: "Explore Research Impact",
    img: scrollimage2,
    link: "/change",
  },
  {
    title: "Approach",
    desc: "Spiritual Data's AI Platform team is responsible for implementing this framework. Their mission: Develop a foundation for AI systems to uphold scientific rigor through automating diverse perspectives, statistically comparing alternative explanations, and justifying all assumptions.",
    btn: "Contribute to the Mission",
    img: scrollimage3,
    link: "/donate",
  },
];

export const estimatingTruthDetailsData = [
  {
    id: 1,
    title: "Evidential Data",
    desc: "Evidential data (research papers, experiences) are imported into a knowledge graph of concepts.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
  {
    id: 2,
    title: "Domains of Knowledge",
    desc: "Concepts live within domains, which are hierarchical and editable by humans. They are populated by relevant literature.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
  {
    id: 3,
    title: "Decision Automation",
    desc: "Decision-automation occurs within each domain. Domains represent the types of questions asked, ideas considered, and concepts used.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
  {
    id: 4,
    title: "Hypothesis Evaluation",
    desc: "Depending on the hypothesis, relevant domains run automation to determine the likelihood of truth.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
  {
    id: 5,
    title: "Confidence Levels",
    desc: "A confidence level is determined based on curated datasets and evidence in the knowledge graph.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
  {
    id: 6,
    title: "Scientific Foundation",
    desc: "This framework provides the foundation of science and statistical justification for Spiritual Data's AI products and recommendations.",
    secHead: "DETAILS",
    secSubHead1: "TRUTH",
    secSubHead2: "ESTIMATION",
  },
];
